import initialState from "../../../store/initialState";
import * as demandTableTypes from "../services/DemandTableActionType";

const types = { ...demandTableTypes };

// Utility to append unique rows (prevents duplicates)
const mergeUniqueByKey = (oldData = [], newData = [], key) => {
  const map = new Map();
  [...oldData, ...newData].forEach((item) => {
    if (item && item[key] !== undefined) {
      map.set(item[key], item);
    }
  });
  return Array.from(map.values());
};

const demandTableReducer = (
  state = initialState.demandTableReducer,
  action,
) => {
  switch (action.type) {
    // Volume Trend Reports Dropdown Binding - start
    case types.FETCH_VOLUME_TREND_REPORTS_DD_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_VOLUME_TREND_REPORTS_DD_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        reportsDDList: action.payload?.values.reportsDDList || [],
      };
    case types.FETCH_VOLUME_TREND_REPORTS_DD_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        reportsDDList: [],
      };
    // Volume Trend Reports Dropdown Binding- end

    // Reports Tab (Pagination) - start
    case types.FETCH_REPORTS_TAB_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_REPORTS_TAB_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        reportsTabData: action.payload?.values || [],
        reportsTabDataTotal: action.payload?.recordsTotal || 0,
      };
    case types.FETCH_REPORTS_TAB_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        reportsTabData: [],
        reportsTabDataTotal: 0,
      };
    // Reports Tab (Pagination) - end

    // Onboarding Tab - start
    case types.FETCH_ONBOARDING_TAB_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_ONBOARDING_TAB_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        onboardingTabData: action.payload?.values || [],
      };
    case types.FETCH_ONBOARDING_TAB_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        onboardingTabData: [],
      };
    // Onboarding Tab - end

    // Notes Edit - start
    case types.FETCH_NOTES_EDIT_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_NOTES_EDIT_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        notesEditData: action.payload?.values || {},
      };
    case types.FETCH_NOTES_EDIT_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        notesEditData: {},
      };
    // Notes Edit - end

    // Notes Save - start
    case types.FETCH_NOTES_SAVE_REQUEST:
      return { ...state, isDemandTableLoading: true, notesSaveSuccess: false };
    case types.FETCH_NOTES_SAVE_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        notesEditData: {},
        notesSaveSuccess: true,
      };
    case types.FETCH_NOTES_SAVE_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        notesEditData: {},
        notesSaveSuccess: false,
      };
    // Notes Save - end

    // Delete Demand Report - start
    case types.DELETE_DEMAND_REPORT_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.DELETE_DEMAND_REPORT_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.DELETE_DEMAND_REPORT_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Delete Demand Report - end

    // Export Reports - start
    case types.EXPORT_REPORTS_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_REPORTS_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_REPORTS_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Reports - end

    // Export Onboarding - start
    case types.EXPORT_ONBOARDING_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_ONBOARDING_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_ONBOARDING_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Onboarding - end

    // Fetch DemandTableID by ReportDropdown onchange - start
    case types.FETCH_DEMAND_TABLE_BY_REPORT_SUCCESS:
      return {
        ...state,
        selectedDemandTableID: action.payload,
      };
    // Fetch DemandTableID by ReportDropdown onchange - end

    // Demand Input Filter Dropdown Binding - start
    case types.FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        GetDemandInputFilterDDList: action.payload || {
          practiceDDL: [],
          workListDDL: [],
          dayDDL: [],
        },
      };
    case types.FETCH_GET_DEMAND_INPUT_FILTER_DD_LIST_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        GetDemandInputFilterDDList: {
          practiceDDL: [],
          workListDDL: [],
          dayDDL: [],
        },
      };
    // Demand Input Filter Dropdown Binding - end

    // Worklist By Site Dropdown Binding (Demand Changes Facility sub-tab cascade) - start
    case types.FETCH_WORKLIST_BY_SITE_DD_LIST_REQUEST:
      return { ...state, isWorklistBySiteDDLoading: true };
    case types.FETCH_WORKLIST_BY_SITE_DD_LIST_SUCCESS:
      return {
        ...state,
        isWorklistBySiteDDLoading: false,
        worklistBySiteDDL: action.payload || [],
      };
    case types.FETCH_WORKLIST_BY_SITE_DD_LIST_FAILURE:
      return {
        ...state,
        isWorklistBySiteDDLoading: false,
        worklistBySiteDDL: [],
      };
    // Worklist By Site Dropdown Binding - end

    // Worklist With Site Mapping Dropdown Binding (Demand Changes Worklist sub-tab) - start
    case types.FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_REQUEST:
      return { ...state, isWorklistWithSiteMappingDDLoading: true };
    case types.FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_SUCCESS:
      return {
        ...state,
        isWorklistWithSiteMappingDDLoading: false,
        worklistWithSiteMappingDDL: action.payload || [],
      };
    case types.FETCH_WORKLIST_WITH_SITE_MAPPING_DD_LIST_FAILURE:
      return {
        ...state,
        isWorklistWithSiteMappingDDLoading: false,
        worklistWithSiteMappingDDL: [],
      };
    // Worklist With Site Mapping Dropdown Binding - end

    // Worklist By Worklist Group Dropdown Binding (Demand Table grid cascade) - start
    case types.FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_REQUEST:
      return { ...state, isWorklistByGroupDDLoading: true };
    case types.FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_SUCCESS:
      return {
        ...state,
        isWorklistByGroupDDLoading: false,
        worklistByGroupDDL: action.payload || [],
      };
    case types.FETCH_WORKLIST_BY_WORKLISTGROUP_DD_LIST_FAILURE:
      return {
        ...state,
        isWorklistByGroupDDLoading: false,
        worklistByGroupDDL: [],
      };
    // Worklist By Worklist Group Dropdown Binding - end

    // Demand Table (6th Tab) - start
    case types.FETCH_DEMAND_TABLE_TAB_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_DEMAND_TABLE_TAB_SUCCESS:
      return {
        ...state,
        demandTableTabData:
          action.payload?.values?.ListDemandTableDemandData || [],
        demandTableTotalRecords: action.payload?.values?.recordsTotal || 0,
        isDemandTableLoading: false,
      };
    case types.FETCH_DEMAND_TABLE_TAB_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        demandTableTabData: [],
      };

    // All Tabs Data - GetDemandTableById - start
    case types.FETCH_DEMAND_TABLE_BY_ID_REQUEST:
      return {
        ...state,
        isTermedLoading: action.payload.TabNumber === 5.1,
        isOffboardingLoading: action.payload.TabNumber === 5.2,
        isEndedDayLightSavingLoading: action.payload.TabNumber === 4.1,
        isUpcomingDayLightSavingLoading: action.payload.TabNumber === 4.2,
        // TabNumber 3.1 now serves the Worklist sub-tab (Phase 2 backend swap —
        // was Practice); keep the flag name aligned with what it actually loads.
        isWorklistDemandChangesLoading: action.payload.TabNumber === 3.1,
        isSiteDemandChangesLoading: action.payload.TabNumber === 3.2,
        isDemandInputAccumulatedLoading: action.payload.TabNumber === 1,
        isOnboardingTabLoading: action.payload.TabNumber === 2,
      };

    case types.FETCH_DEMAND_TABLE_BY_ID_SUCCESS: {
      const response = action.payload?.values || {};

      return {
        ...state,

        // Demand Input Tab Data (real Day/Site/PriorityGroup accumulation) - start
        demandInputAccumulated:
          action.payload.TabNumber === 1
            ? response.DemandInputAccumulated || { Rows: [] }
            : state.demandInputAccumulated,
        // Demand Input Tab Data - end

        // Onboarding Tab Data (report-scoped snapshot, TabNumber=2) - start
        // Shares the onboardingTabData slice with the live FETCH_ONBOARDING_TAB_*
        // path — the component reads one field regardless of which source fetched it.
        onboardingTabData:
          action.payload.TabNumber === 2
            ? response.listDemandInputOnboardingData || []
            : state.onboardingTabData,
        // Onboarding Tab Data - end

        //Offboarding Tab Data - start
        termedTableData:
          action.payload.TabNumber === 5.1
            ? response.listDemandInputTermedData || []
            : state.termedTableData,

        offboardingTableData:
          action.payload.TabNumber === 5.2
            ? response.listDemandInputOffboardData || []
            : state.offboardingTableData,
        // Offboarding Tab Data - end

        // Day Light Saving Tab Data - start
        dayLightSavingEndedData:
          action.payload.TabNumber === 4.1
            ? response.listDemandInputDaylightSavingEndedData || []
            : state.dayLightSavingEndedData,

        dayLightSavingUpcomingData:
          action.payload.TabNumber === 4.2
            ? response.listDemandInputDaylightSavingUpcomingData || []
            : state.dayLightSavingUpcomingData,
        // Day Light Saving Tab Data - end

        // Demand Changes Tab Data - start
        // Replace (not merge) — this is the full, authoritative list for the
        // CURRENT report's tab, already scoped server-side by DemandTableReportID.
        // Merging here previously let a previous report's rows survive across
        // reports in the same session (the component only clears state on
        // unmount, not on Publish/Save-as-Draft/Cancel).
        demandChangesWorklistData:
          action.payload.TabNumber === 3.1
            ? response.listDemandChangesWorklistData || []
            : state.demandChangesWorklistData,
        demandChangesSiteData:
          action.payload.TabNumber === 3.2
            ? response.listDemandChangesSiteData || []
            : state.demandChangesSiteData,
        // Demand Changes Tab Data - end

        isEndedDayLightSavingLoading: false,
        isUpcomingDayLightSavingLoading: false,
        isTermedLoading: false,
        isOffboardingLoading: false,
        isWorklistDemandChangesLoading: false,
        isSiteDemandChangesLoading: false,
        isDemandInputAccumulatedLoading: false,
        isOnboardingTabLoading: false,
      };
    }

    case types.FETCH_DEMAND_TABLE_BY_ID_FAILURE:
      return {
        ...state,
        isTermedLoading: false,
        isOffboardingLoading: false,
        isEndedDayLightSavingLoading: false,
        isUpcomingDayLightSavingLoading: false,
        isDemandInputAccumulatedLoading: false,
        isWorklistDemandChangesLoading: false,
        isSiteDemandChangesLoading: false,
        isOnboardingTabLoading: false,
      };
    // All Tabs Data - GetDemandTableById - end

    // Export Termed and offboarding CSV  - start
    case types.EXPORT_TERMED_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_TERMED_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_TERMED_FAILURE:
      return { ...state, isDemandTableLoading: false };

    case types.EXPORT_OFFBOARDING_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_OFFBOARDING_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_OFFBOARDING_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Termed and offboarding CSV  - end

    // Export Daylight Saving CSV - start
    case types.EXPORT_ENDED_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_ENDED_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_ENDED_FAILURE:
      return { ...state, isDemandTableLoading: false };

    case types.EXPORT_UPCOMING_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_UPCOMING_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_UPCOMING_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Daylight Saving CSV - end

    // Bulk Update Practice - start
    case types.BULK_UPDATE_PRACTICE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.BULK_UPDATE_PRACTICE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.BULK_UPDATE_PRACTICE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Bulk Update Practice - end

    // Bulk Update Site - start
    case types.BULK_UPDATE_SITE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.BULK_UPDATE_SITE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.BULK_UPDATE_SITE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Bulk Update Site - end

    // Bulk Delete Practice - start
    case types.BULK_DELETE_PRACTICE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.BULK_DELETE_PRACTICE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.BULK_DELETE_PRACTICE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Bulk Delete Practice - end

    // Bulk Delete Site - start
    case types.BULK_DELETE_SITE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.BULK_DELETE_SITE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.BULK_DELETE_SITE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Bulk Delete Site - end

    // Bulk Update Worklist - start
    case types.BULK_UPDATE_WORKLIST_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.BULK_UPDATE_WORKLIST_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.BULK_UPDATE_WORKLIST_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Bulk Update Worklist - end

    // Bulk Delete Worklist - start
    case types.BULK_DELETE_WORKLIST_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.BULK_DELETE_WORKLIST_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.BULK_DELETE_WORKLIST_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Bulk Delete Worklist - end

    // Export Practice - start
    case types.EXPORT_PRACTICE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_PRACTICE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_PRACTICE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Practice - end

    // Export Site - start
    case types.EXPORT_SITE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_SITE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_SITE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Site - end

    // Export Worklist - start
    case types.EXPORT_WORKLIST_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.EXPORT_WORKLIST_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.EXPORT_WORKLIST_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Export Worklist - end

    // Fetch Demand Changes Practice Data - start
    case types.FETCH_DEMAND_CHANGES_PRACTICE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_DEMAND_CHANGES_PRACTICE_SUCCESS: {
      const newData = action.payload?.values || [];
      const mergedData = mergeUniqueByKey(
        state.demandChangesPracticeData || [],
        newData,
        "DemandChangesPracticeId",
      );
      return {
        ...state,
        isDemandTableLoading: false,
        demandChangesPracticeData: mergedData,
      };
    }
    case types.FETCH_DEMAND_CHANGES_PRACTICE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Fetch Demand Changes Practice Data - end

    // Fetch Demand Changes Site Data - start
    case types.FETCH_DEMAND_CHANGES_SITE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_DEMAND_CHANGES_SITE_SUCCESS: {
      const newData = action.payload?.values || [];
      const mergedData = mergeUniqueByKey(
        state.demandChangesSiteData || [],
        newData,
        "DemandChangesSiteId",
      );
      return {
        ...state,
        isDemandTableLoading: false,
        demandChangesSiteData: mergedData,
      };
    }
    case types.FETCH_DEMAND_CHANGES_SITE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Fetch Demand Changes Site Data - end

    // Fetch/Apply Demand Changes Worklist Data - start
    case types.FETCH_DEMAND_CHANGES_WORKLIST_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_DEMAND_CHANGES_WORKLIST_SUCCESS: {
      const newData = action.payload?.values || [];
      const mergedData = mergeUniqueByKey(
        state.demandChangesWorklistData || [],
        newData,
        "DemandChangesWorklistId",
      );
      return {
        ...state,
        isDemandTableLoading: false,
        demandChangesWorklistData: mergedData,
      };
    }
    case types.FETCH_DEMAND_CHANGES_WORKLIST_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Fetch/Apply Demand Changes Worklist Data - end

    // Refresh Demand Table Data - start
    case types.REFRESH_DEMAND_TABLE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.REFRESH_DEMAND_TABLE_SUCCESS:
      return { ...state, isDemandTableLoading: false };
    case types.REFRESH_DEMAND_TABLE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // Refresh Demand Table Data - end

    // Reset Demand Table Reducer - end

    // Save As Draft - start
    case types.SAVE_AS_DRAFT_REQUEST:
      return { ...state, isDemandTableLoading: true, draftError: null };
    case types.SAVE_AS_DRAFT_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        draftSavedData: action.payload,
      };
    case types.SAVE_AS_DRAFT_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        draftError: action.payload,
      };
    // Save As Draft - end

    // Publish Demand Table - start
    case types.PUBLISH_DEMAND_TABLE_REQUEST:
      return { ...state, isDemandTableLoading: true, publishError: null };
    case types.PUBLISH_DEMAND_TABLE_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        publishData: action.payload,
      };
    case types.PUBLISH_DEMAND_TABLE_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        publishError: action.payload,
      };
    // Publish Demand Table - end

    // View Demand Table - start
    case types.VIEW_DEMAND_TABLE_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.VIEW_DEMAND_TABLE_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        onboardingTabData: action.payload.onboardingTabData ?? [],
        demandChangesWorklistData:
          action.payload.demandChangesWorklistData ?? [],
        demandChangesSiteData: action.payload.demandChangesSiteData ?? [],
        dayLightSavingEndedData: action.payload.dayLightSavingEndedData ?? [],
        dayLightSavingUpcomingData:
          action.payload.dayLightSavingUpcomingData ?? [],
        offboardingTableData: action.payload.offboardingTableData ?? [],
        termedTableData: action.payload.termedTableData ?? [],
        demandInputFilters: action.payload.demandInputFilters ?? {},
        demandInputAccumulated: action.payload.demandInputAccumulated ?? {
          Rows: [],
        },
        activeTab: action.payload.activeTab ?? state.activeTab,
        isVolumeTrendLocked:
          action.payload.isVolumeTrendLocked ?? state.isVolumeTrendLocked,
        enabledTabs: action.payload.enabledTabs ?? state.enabledTabs,
        disabledTabs: action.payload.disabledTabs ?? state.disabledTabs,
      };
    case types.VIEW_DEMAND_TABLE_FAILURE:
      return { ...state, isDemandTableLoading: false };
    // View Demand Table - end

    // Holiday Coverage Worklist Data - start
    case types.FETCH_HOLIDAY_COVERAGE_WORKLIST_REQUEST:
      return { ...state, isDemandTableLoading: true };
    case types.FETCH_HOLIDAY_COVERAGE_WORKLIST_SUCCESS:
      return {
        ...state,
        isDemandTableLoading: false,
        holidayCoverageWorklistData:
          action.payload?.values?.listDemandHolidayCoverageWorklistData || [],
        holidayCoveragePracticeData:
          action.payload?.values?.listDemandHolidayCoveragePracticeData || [],
        holidayCoverageSiteData:
          action.payload?.values?.listDemandHolidayCoverageSiteData || [],
      };
    case types.FETCH_HOLIDAY_COVERAGE_WORKLIST_FAILURE:
      return {
        ...state,
        isDemandTableLoading: false,
        holidayCoverageWorklistData: [],
        holidayCoveragePracticeData: [],
        holidayCoverageSiteData: [],
      };
    // Holiday Coverage Worklist Data - end

    // Common cases
    case types.UPDATE_DEMAND_TABLE_REDUCER:
      return { ...state, ...action.payload };

    case types.RESET_DEMAND_TABLE_STATE:
      return { ...initialState.demandTableReducer };

    default:
      return state;
  }
};

export default demandTableReducer;
